import {
  Box,
  getValueByDevice,
  Grid,
  GridItem,
  useAvailableHeight,
  useDevice,
} from 'platform/foundation';
import {styled} from 'styled-components';

import {Children, isValidElement, ReactNode} from 'react';

interface Props {
  children: ReactNode;
}

const Left = ({children}: Props) => children;
const Right = ({children}: Props) => children;

// eslint-disable-next-line eag/no-css-property
const FullHeight = styled.div`
  height: 100%;
  & > div {
    height: 100%;
  }
`;

export function VehicleFormDefaultLayout({children}: Props) {
  const childrenArray = Children.toArray(children);

  const leftChild = childrenArray.find((child) => isValidElement(child) && child.type === Left);

  const rightChild = childrenArray.find((child) => isValidElement(child) && child.type === Right);

  const device = useDevice();
  const responsiveMode = getValueByDevice(device, true, true, true, false);
  const {availableHeightRef, availableHeight} = useAvailableHeight<HTMLDivElement>();

  return (
    <Box
      ref={availableHeightRef}
      backgroundColor="general.white"
      width="100%"
      height={availableHeight}
      borderBottomRightRadius="medium"
    >
      <FullHeight>
        <Grid columns={[1, 1, 1, 3]}>
          <GridItem span={[1, 1, 1, 2]}>
            <Box width="100%" height="100%" padding={4}>
              {leftChild}
            </Box>
          </GridItem>
          <GridItem>
            <Box
              width="100%"
              height="100%"
              paddingHorizontal={responsiveMode ? 0 : 4}
              paddingTop={responsiveMode ? 0 : 4}
              paddingBottom={4}
            >
              <Box
                width="100%"
                height="100%"
                backgroundColor={responsiveMode ? 'general.white' : 'palettes.neutral.20.100'}
                borderRadius="medium"
                padding={4}
              >
                {rightChild}
              </Box>
            </Box>
          </GridItem>
        </Grid>
      </FullHeight>
    </Box>
  );
}

// Attach sub-components to main component
VehicleFormDefaultLayout.Left = Left;
VehicleFormDefaultLayout.Right = Right;
